// extracted by css-extract-rspack-plugin
export default {"prof":"squMca2TF14UBL9a","list":"nX5JR1YeV46HAbf9","active":"mCVVtP2FjVEqW1eV","left":"ZB_ZO3nf3xwlnTrQ","right":"VU91RyTisVTSaGc6","new_car_padding":"jDrpetwH3x0HBAcg"};